import React, {useState, Fragment, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Fab from '@material-ui/core/Fab'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'

// Material-UI Icon
import DescriptionIcon from '@material-ui/icons/Description'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import DeleteIcon from '@material-ui/icons/Delete'
import GetAppIcon from '@material-ui/icons/GetApp'
import AddIcon from '@material-ui/icons/Add'

// Custom Component
import ConfirmDialog from '../Dialog/ConfirmDialog'

// Custom Style
import {fileZoneContentStyle} from '../../styles/jss/components/documentSubmission/fileZoneContentStyle'

// Fetch Data
import {fileDownload} from '../../dataSource/fileManager'


const useStyles = makeStyles(theme => fileZoneContentStyle(theme))

const CreateFormZoneContent = props => {
	const dispatch = useDispatch()
	const classes = useStyles()
	const {title, fileType, open, required, error, helperText} = props

	// Redux Data
	const documentSubmissionCreateValueRedux = useSelector(state => state.documentSubmissionCreateValueRedux)

	const [submissionCreateProperty, setSubmissionCreateProperty] = useState(null)
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	// Build Confirm Dialog
	const confirmDialogHandleOpen = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})

		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Main Action
	const removeFileConfirmAction = (fileElementName, fileSeq) => {
		confirmDialogHandleOpen({
			dialogTitle: "Document Submission file remove",
			dialogContent: "Do you want to remove the file.",
			confirmAction: () => removeFileAction(fileElementName, fileSeq),
			cancelAction: removeFileCancelAction
		})
	}

	const removeFileCancelAction = () => {
		confirmDialogHandleClose()
	}

	const removeFileAction = (fileElementName, fileSeq) => {
		confirmDialogHandleClose()
		const val = {...submissionCreateProperty.files}

		val[fileElementName].map((res, index) => {
			if (res.file_seq == fileSeq) {
				val[fileElementName].splice(index, 1)

				setSubmissionCreateProperty({...submissionCreateProperty, files: val})
				dispatch({
					type: "ADD_DOCUMENT_SUBMISSION_CREATE_VALUE",
					data: {...submissionCreateProperty, files: val}
				})

				console.log("*****************************************************************************")
				console.log("System Module: Document Submission")
				console.log("Message: File remove successful.")
				console.log(res)
				console.log("*****************************************************************************")
			}
		})
	}

	const downloadFileAction = (fileCat, fileSeq) => {
		fileDownload(fileCat, fileSeq).then(res => {
			console.log("*****************************************************************************")
			console.log("System Module: Document Submission")
			console.log("Message: File download successful.")
			console.log("*****************************************************************************")
		})
	}

	
	useEffect(() => {
		setSubmissionCreateProperty(documentSubmissionCreateValueRedux)
	})


	return (
		// console.log("Submission Create Property | Variable: submissionCreateProperty (CreateFormZoneContent.js)"),
		// console.log(submissionCreateProperty),

		// console.log("Document Create Property (Redux) | Variable: documentSubmissionCreateValueRedux (CreateFormZoneContent.js)"),
		// console.log(documentSubmissionCreateValueRedux),

		// console.log("---------------------------------------------------------------------------------"),

		
		<Fragment>
			<ConfirmDialog
				open={confirmDialogOpen}
				dialogTitle={confirmDialogData.dialogTitle}
				dialogContent={confirmDialogData.dialogContent}
				confirmAction={confirmDialogData.confirmAction}
				cancelAction={confirmDialogData.cancelAction}
			/>

			<Box border={1} borderRadius="borderRadius" borderColor={required ? error ? "error.main" : "grey.400" : "grey.400"} className={classes.fileList}>
				<Typography variant="button" color={required ? error ? "error" : "textPrimary" : "textPrimary"}>{title}</Typography>

				<List>
				{
					documentSubmissionCreateValueRedux !== null ?
						Array.isArray(documentSubmissionCreateValueRedux.files[fileType]) ?
							documentSubmissionCreateValueRedux.files[fileType].map((res, index) => {
								return (
									<div key={index}>
										<ListItem>
											<ListItemAvatar>
												<Avatar>
													<DescriptionIcon />
												</Avatar>
											</ListItemAvatar>
											<ListItemText primary={res.filename} secondary={"Last updated: " + res.modifydate} />

											<ListItemSecondaryAction>
												{/* <Tooltip title="View File">
													<Fab color="primary" size="small" aria-label="view" className={classes.attachmentBtn} onClick={() => previewFileAction("master", res.file_seq)}>
														<LaunchIcon />
													</Fab>
												</Tooltip> */}

												<Tooltip title="Download File">
													<Fab color="primary" size="small" aria-label="download" className={classes.attachmentBtn} onClick={() => downloadFileAction("master", res.file_seq)}>
														<GetAppIcon />
													</Fab>
												</Tooltip>

												<Tooltip title="Remove File">
													<Fab color="primary" size="small" aria-label="delete" className={classes.attachmentBtn} onClick={() => removeFileConfirmAction(fileType, res.file_seq)}>
														<DeleteIcon />
													</Fab>
												</Tooltip>
											</ListItemSecondaryAction>
										</ListItem>

										<Divider className={classes.approveTextDivider} />
									</div>
								)
							})
						: ""
					: ""
				}
				</List>

				<Box className={classes.fileUploadBtnArea}>
					<Tooltip title="Choose File">
						<Fab color="primary" size="small" aria-label="upload_file" className={classes.fileUploadBtn} onClick={open}>
							<AddIcon />
						</Fab>
					</Tooltip>
				</Box>
				
			</Box>
			{
				required ? 
					error ?	<Typography variant="caption" color="error" className={classes.uploadErrorMsg}>{helperText}</Typography> : "" 
				: ""
			}

			
		</Fragment>
	)
}

export default CreateFormZoneContent